import React, { useEffect, useRef } from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FormInputField from '../common/components/formFields/FormInputField';

const initialValues = {
  name: '',
};

const GroupsSearch = ({ handleSearch }) => {
  const formRef = useRef();
  const previousSearchState = useSelector(state => state.groups.get('searchState'));

  useEffect(() => {
    if (previousSearchState?.searchParams) {
      formRef.current.setValues(previousSearchState?.searchParams);
    }
  }, [previousSearchState]);

  return (
    <Card>
      <CardBody>
        <h6>Search groups</h6>
        <Formik
          innerRef={formRef}
          initialValues={initialValues}
          onSubmit={handleSearch}
          validateOnBlur={true}
        >
          {({ resetForm, submitForm }) => (
            <Form noValidate>
              <Row>
                <Col md="4">
                  <FormInputField name="name" label="Name" />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Button color="primary" className="mt-4 float-right" type="submit">
                    Search
                  </Button>
                  <Button
                    color="primary"
                    outline={true}
                    className="mt-4 float-right"
                    type="button"
                    onClick={() => {
                      resetForm();
                      submitForm();
                    }}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
};

GroupsSearch.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};
export default GroupsSearch;
